import { useEffect, useState } from "react";

const failedOrdersJsonData = "/Api/failedOrders.json"; 

const FailedOrdersDetailsLayout = ({
  handleClose,
}: {
  handleClose: () => void;
}) => {
  const [failedOrdersData, setFailedOrdersData] = useState<any[]>([]);

  useEffect(() => {
    fetch(failedOrdersJsonData)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.json();
      })
      .then((response) => {
        setFailedOrdersData(response);
      })
      .catch((err) => console.error("Error loading JSON:", err));
  }, []);

  return (
    <div className="gap-2 overflow-auto p-2">
      {failedOrdersData.map((data, index) => (
        <div key={index} className="mb-3">
          <span className="font-medium">• {data.row} - </span>
          {data.errorDetails.split(",").map((err: string, i: number) => {
            // Highlight the key phrases (like Client Code, Ship to Name)
            const formatted = err
              .replace(/(Client Code|Ship to Name|Part Number|UOM)/g, "<strong>$1</strong>")
              .trim();
            return (
              <span
                key={i}
                className="mr-1"
                dangerouslySetInnerHTML={{ __html: (i > 0 ? ", " : "") + formatted }}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default FailedOrdersDetailsLayout;
